import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';

const OverlaySpinner = ({
  roundedCorners,
  height = 'calc(100% + 48px)',
  width = 'calc(100% + 48px)',
  m = -3,
  p = 2,
}) => (
  <Box
    position="absolute"
    height={height}
    width={width}
    m={m}
    p={p}
    display="flex"
    justifyContent="center"
    alignItems="center"
    style={{
      backgroundColor: 'rgba(0, 0, 0, .05)',
      borderRadius: roundedCorners ? 10 : 0,
    }}
  ></Box>
);

OverlaySpinner.propTypes = {
  roundedCorners: PropTypes.bool,
  height: PropTypes.string,
  width: PropTypes.string,
  m: PropTypes.number,
  p: PropTypes.number,
};

export default OverlaySpinner;
